import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import './styles.scss';
import './assets/styles/banner.css'; 
import './assets/styles/ComingSoon.css'; 
import './assets/styles/FAQSection.css'; 
import './assets/styles/Footer.css'; 
import './assets/styles/HowItWorks.css'; 
import './assets/styles/PricingSection.css'; 
import './assets/styles/RequestCallback.css'; 
import './assets/styles/ServicesSection.css'; 
import './assets/styles/WhyTrustRest.css'; 
import './assets/styles/globals.css';
import './assets/styles/styleguide.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
